import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save, X } from "lucide-react";
import { api } from "@/lib/api";

export const PositionMealBulkModal = ({ onClose, onSaved }) => {
  const [rows, setRows] = useState(null);
  const [vals, setVals] = useState({});
  const [all, setAll] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/position-templates").then((r) => {
      const list = Array.isArray(r.data) ? r.data : r.data.rows || [];
      setRows(list);
      setVals(Object.fromEntries(list.map((t) => [t.id, t.varsayilan_yemek ?? ""])));
    }).catch(() => { toast.error("Pozisyonlar yüklenemedi"); onClose(); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    setBusy(true);
    try {
      const items = rows.map((t) => ({ id: t.id, varsayilan_yemek: vals[t.id] === "" || vals[t.id] == null ? null : Number(vals[t.id]) }));
      const r = await api.put("/position-templates/bulk-yemek", { items });
      toast.success(`${r.data.changed} pozisyonun yemek tutarı güncellendi`);
      onSaved?.(); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Kaydedilemedi"); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" data-testid="position-meal-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col">
        <div className="p-3 border-b flex items-center justify-between">
          <div>
            <div className="text-sm font-bold text-slate-900">Pozisyon Yemek Tutarları</div>
            <div className="text-[11px] text-slate-500">Günlük tutar · kişiye özel tutar girilmemiş personel bu tutarı alır</div>
          </div>
          <button onClick={onClose} data-testid="position-meal-close" className="w-7 h-7 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={14} /></button>
        </div>
        {!rows ? <div className="p-8 text-center text-slate-400"><Loader2 size={16} className="inline animate-spin" /></div> : (
          <>
            <div className="px-3 pt-3 flex gap-2">
              <input type="number" min="0" step="0.01" value={all} onChange={(e) => setAll(e.target.value)} placeholder="Tümüne aynı tutar"
                data-testid="position-meal-all" className="flex-1 px-2 py-1.5 border border-slate-300 rounded-md text-sm" />
              <button onClick={() => all !== "" && setVals(Object.fromEntries(rows.map((t) => [t.id, all])))} data-testid="position-meal-apply-all"
                className="px-3 py-1.5 bg-slate-900 text-white rounded-md text-xs font-semibold">Tümüne Uygula</button>
            </div>
            <div className="p-3 overflow-y-auto space-y-1">
              {rows.map((t) => (
                <div key={t.id} className="flex items-center gap-2 px-2 py-1.5 border border-slate-200 rounded-md">
                  <span className="flex-1 text-sm font-semibold text-slate-800">{t.isim}</span>
                  <span className="text-[10px] text-slate-400">{t.usage_count ?? 0} kişi</span>
                  <input type="number" min="0" step="0.01" value={vals[t.id]} placeholder="—" data-testid={`position-meal-${t.id}`}
                    onChange={(e) => setVals({ ...vals, [t.id]: e.target.value })}
                    className="w-28 px-2 py-1 border border-slate-300 rounded text-sm text-right font-mono-tab" />
                  <span className="text-xs text-slate-500">₺</span>
                </div>
              ))}
            </div>
            <div className="p-3 border-t flex justify-end gap-2 bg-slate-50 rounded-b-xl">
              <button onClick={onClose} className="px-3 py-1.5 border border-slate-300 rounded-lg text-sm font-semibold">İptal</button>
              <button onClick={save} disabled={busy} data-testid="position-meal-save"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-teal-700 hover:bg-teal-800 text-white rounded-lg text-sm font-semibold disabled:opacity-50">
                {busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Hepsini Kaydet
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
